import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(theme => ({
  markerTrendsGraph: {
    display: 'flex',
    flexDirection: 'column',
    borderTop: '1px solid rgba(0, 0, 0, 0.12)',
  },
  selectsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: '8px',
  },
  selectPreWrapper: {
    display: 'flex',
    flexDirection: 'row',
    columnGap: '20px',
  },
  selectWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  selectInput: {
    fontSize: '14px !important',
    fontWeight: '600 !important',
    padding: '8px 32px 8px 8px !important',
  },
  selectMenu: {
    '& .MuiMenuItem-root': {
      fontSize: '14px',
    },
  },
  graphWrapper: {
    paddingTop: '16px',
    display: 'flex',
    flexDirection: 'row',
    gap: '16px',
    height: '560px',

    '@media (max-width: 1000px)': {
      flexDirection: 'column',
      height: '100%',
    },
  },
  graph: {
    height: '100%',
    width: '70%',

    '@media (max-width: 1000px)': {
      width: '100%',
      height: '460px',
    },

    // '@media (max-width: 500px)': {
    //   width: '100%',
    //   height: '460px'
    // }
  },
  graphLabel: {
    textAnchor: 'middle',
  },
  legendWrapper: {
    display: 'flex',
    flexDirection: 'column',
    overflowX: 'auto',
    flexWrap: 'wrap',
    height: '110px',
    gap: '4px',
    padding: '8px 0px 4px',
    marginLeft: '60px',
    marginRight: '60px',
  },
  legendItemWrapper: {
    display: 'flex',
    alignItems: 'center',
    columnGap: '4px',
    paddingRight: '8px',
  },
  legendDivider: {
    marginRight: '8px !important',
  },
  colorCircle: {
    height: '10px',
    width: '10px',
    minWidth: '10px',
  },
  tooltipWrapper: {
    borderRadius: '6px',
    backgroundColor: '#E5E5E5',
    overflowY: 'auto',
    height: '100%',

    '@media (max-width: 1000px)': {
      width: '100%',
      height: '300px',
    },
  },
  noYearSelected: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  },
  insufficientData: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    color: 'red',
    fontWeight: '600',
  },
  // sliderCont: {
  //   width: '30%',
  //   overflowY: 'auto',
  //   overflowX: 'hidden',
  //   '@media (max-width: 1000px)': {
  //     width: '100%',
  //     overflowY: 'hidden',
  //     overflowX: 'hidden',
  //   },
  // },
  tooltip: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  tooltipTitle: {
    display: 'flex',
    flexDirection: 'row',
    columnGap: '8px',
    alignItems: 'flex-end',
    padding: '8px 12px 6px',
    borderBottom: '1px solid #fff',
  },
  tooltipItemWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    columnGap: '6px',
    minWidth: 0,
  },
  tooltipItemBox: {
    height: '10px',
    width: '10px',
    border: 'solid rgb(0, 0, 0, 0.75) 0.5px',
    flex: 'none',
  },
  tooltipItemBoxSmall: {
    height: '10px',
    width: '10px',
    border: 'solid rgb(0, 0, 0, 0.75) 0.5px',
    flex: 'none',
  },
  tooltipItemStats: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
    minWidth: 0,
    gap: '6px',
  },
  chartTooltipLabel: {
    backgroundColor: '#fff',
    padding: '8px',
    border: 'solid rgba(0, 0, 0, 0.25) 1px',
  },
  tooltipSubTitle: {
    padding: '16px 0px',
  },
  tooltipContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '3px',
    padding: '8px 12px',
    overflowY: 'auto',
  },
  formGroup: {
    paddingLeft: '12px',
  },
  rightSide: {
    display: 'flex',
    flexDirection: 'column',
    width: '30%',
    rowGap: '8px',

    '@media (max-width: 1000px)': {
      width: '100%',
    },
  },
  floatingFilter: {
    position: 'absolute',
    top: 16,
    right: -(280 + 16),
    width: '280px',
    zIndex: 1,

    '@media (max-width: 1900px)': {
      right: 16,
    },
  },
  titleWrapper: {
    paddingBottom: '8px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  labelWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    columnGap: '8px',
    paddingBottom: '4px',
  },
}));

export { useStyles };
